import { render, staticRenderFns } from "./UserinfoPage.vue?vue&type=template&id=52d3e135&scoped=true"
import script from "./UserinfoPage.vue?vue&type=script&lang=js"
export * from "./UserinfoPage.vue?vue&type=script&lang=js"
import style0 from "./UserinfoPage.vue?vue&type=style&index=0&id=52d3e135&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d3e135",
  null
  
)

export default component.exports